import { Box, styled } from "@mui/material";
import { DataGridPro, DataGridProProps } from "@mui/x-data-grid-pro";
import { useContext } from "react";
import { AppContext } from "../../common/contexts/app_context/app_context";

interface Props extends DataGridProProps {
  height?: string
}

function StyledDataGrid({ height = "60vh", ...props }: Props) {
  const mode = useContext(AppContext).theme
  const StyledDataGrid = styled(DataGridPro)(({ theme }) => ({
    "& .MuiDataGrid-footerContainer": {
      display: "none",
    },
    backgroundColor: mode === "dark" ? "#2C2C2C" : "#FFFFFF"
  }));

  return (
    <Box sx={{ height: height, width: '100%' }}>
      <StyledDataGrid
        {...props}
      />
    </Box>
  );
}

export default StyledDataGrid;
